const events = [
  {
    type: 'Conference',
    icon: 'ri-megaphone-line',
    title: 'Gaming Istanbul 2026',
    description: 'We take the stage as panelists at Turkey\'s largest gaming event, holding one-on-one sessions with studios throughout the conference.',
    date: 'September 2026',
    location: 'Istanbul',
    image: 'https://readdy.ai/api/search-image?query=Large%20gaming%20conference%20hall%20with%20illuminated%20stage%20and%20audience%2C%20warm%20amber%20and%20teal%20stage%20lighting%2C%20professional%20event%20atmosphere%2C%20large%20LED%20screens%20displaying%20game%20graphics%2C%20modern%20convention%20center%20interior%2C%20energetic%20crowd%2C%20wide%20angle%20view&width=800&height=500&seq=coreloop-event-istanbul&orientation=landscape',
  },
  {
    type: 'Workshop',
    icon: 'ri-lightbulb-line',
    title: 'Game Design Masterclass',
    description: 'An interactive training program for studio teams focused on game mechanics and player experience — from theory to hands-on practice.',
    date: 'October 2026',
    location: 'Ankara',
    image: 'https://readdy.ai/api/search-image?query=Interactive%20workshop%20setting%20with%20creative%20professionals%20collaborating%20around%20a%20table%2C%20whiteboards%20with%20game%20design%20diagrams%2C%20warm%20modern%20studio%20lighting%2C%20casual%20creative%20atmosphere%2C%20sticky%20notes%20and%20sketches%2C%20design%20thinking%20session&width=800&height=500&seq=coreloop-event-workshop&orientation=landscape',
  },
  {
    type: 'Networking',
    icon: 'ri-group-line',
    title: 'Game Dev Mixer Izmir',
    description: 'An informal gathering with the game developer community. A great opportunity for networking, knowledge sharing, and potential collaborations.',
    date: 'November 2026',
    location: 'Izmir',
    image: 'https://readdy.ai/api/search-image?query=Casual%20networking%20event%20in%20a%20modern%20loft%20space%20with%20creative%20professionals%20mingling%2C%20warm%20ambient%20lighting%2C%20industrial%20chic%20interior%20with%20exposed%20brick%2C%20standing%20tables%20with%20drinks%2C%20relaxed%20social%20atmosphere%2C%20evening%20event%2C%20game%20industry%20mixer&width=800&height=500&seq=coreloop-event-mixer&orientation=landscape',
  },
];

export default function EventsSection() {
  return (
    <section id="events" className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-3">Events</span>
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 mb-4">
            Where to Find Us
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            We actively participate in gaming events, workshops, and industry meetups across Turkey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {events.map((event) => (
            <div
              key={event.title}
              className="group relative bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-500 hover:border-accent-200/60"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-semibold px-3 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800 whitespace-nowrap">
                    {event.type}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line text-sm"></i>
                    {event.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-map-pin-line text-sm"></i>
                    {event.location}
                  </span>
                </div>
                <h3 className="text-lg font-bold font-heading text-foreground-900 mb-2">{event.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}